<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('edit') }} {{ $t('shortDomains.shortDomain') }}
                <template v-if="isLoaded && shortDomain.id"> #{{ shortDomain.id }} </template>

                <div
                    v-if="isLoaded"
                    class="pull-right"
                >
                    <router-link
                        v-if="shortDomain.id"
                        :to="{
                            name: 'short-domains.show',
                            params: { id: shortDomain.id },
                        }"
                        class="btn btn-sm btn-primary"
                    >
                        <span class="sr-only">{{ $t('shortDomains.backToShortDomain') }}</span>
                        <span class="hidden-xs">{{ $t('shortDomains.backToShortDomain') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-arrow-left"></i>
                        </span>
                    </router-link>

                    <router-link
                        v-else
                        :to="{ name: 'short-domains.list' }"
                        class="btn btn-sm btn-default"
                    >
                        <span class="sr-only">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="hidden-xs">{{ $t('shortDomains.shortDomainsList') }}</span>
                        <span class="visible-xs">
                            <i class="fa fa-list-ul"></i>
                        </span>
                    </router-link>
                </div>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="row">
                <div class="col-xs-12">
                    <div class="box box-primary">
                        <div
                            v-if="!isLoaded"
                            class="box-body"
                        >
                            <img
                                class="table-row-preloader"
                                rel="preload"
                                src="/img/table-row-preloader.gif"
                            />
                        </div>

                        <ShortDomainsForm
                            v-show="isLoaded"
                            :shortDomainId="shortDomainId"
                            @loaded="onLoaded"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ShortDomainsForm from '@/components/short-domains/ShortDomainsForm';

export default {
    components: {
        ShortDomainsForm,
    },

    data() {
        return {
            isLoaded: false,
            shortDomainId: Number(this.$route.params.id),
            shortDomain: {},
        };
    },

    computed: {
        headTitle() {
            return this.shortDomain.id && `${this.$t('shortDomains.shortDomain')} #${this.shortDomain.id} ${this.$t('edit')}`;
        },
    },

    methods: {
        onLoaded(shortDomain) {
            this.shortDomain = shortDomain;
            this.isLoaded = true;
        },
    },
};
</script>
